// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Ellipsis = function Ellipsis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#ellipsis-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.379 10a1.88 1.88 0 0 0 1.881 1.875 1.874 1.874 0 1 0 0-3.75h-.012A1.87 1.87 0 0 0 14.378 10M8.123 10a1.88 1.88 0 0 0 1.881 1.875 1.874 1.874 0 1 0 0-3.75h-.012A1.87 1.87 0 0 0 8.123 10M1.867 10a1.88 1.88 0 0 0 1.881 1.875 1.874 1.874 0 1 0 0-3.75h-.012A1.87 1.87 0 0 0 1.867 10"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ellipsis-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.25 0h17.5v20H1.25z"
  }))));
};
